export const div = (x, y) => Math.floor(x / y)


export function round2Places(number,places){
  
  var p = Math.pow(10, places);
  return Number(Number((Math.fround(number * p) / p).toFixed(places)).toFixed(2));
}
